import styled from 'styled-components';
import { devices } from "../data/constants";

export const ProductModalStyled = styled.div`
    width: 95%;
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
    border-radius: 12px;
    z-index: 99;
    background: ${({ theme }) => theme.colors.cardBG};
    color: ${({ theme }) => theme.colors.cardText};
    font-family: ${({ theme }) => theme.colors.ff};
    padding: 32px 24px;
    touch-action: pan-y;
    @media only screen and ${devices.md} {
        width: 90%;
        padding: 20px 12px;
        margin-bottom: 20px;
    }
`;

export const ProductsContainerStyled = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    width: 100%;
    padding: 16px 0;
    @media only screen and ${devices.lg} {
        grid-template-columns: repeat(2, 1fr);
    }
    @media only screen and ${devices.sm} {
        grid-template-columns: 1fr;
    }
`;

export const CloseButton = styled.div`
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const ProductCardStyled = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    border: 2px solid ${({ $highlighted, theme }) =>
        $highlighted ? theme.colors.activeColor : theme.colors.borderColor};
    padding: 24px 20px;
    position: relative;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    &:hover {
        border-color: ${({ theme }) => theme.colors.activeColor};
        box-shadow: ${({ theme }) => theme.colors.boxShadow};
    }
    @media only screen and ${devices.md} {
        padding: 20px 16px;
    }
`;

export const BadgeStyled = styled.div`
    position: absolute;
    top: -13px;
    left: 50%;
    transform: translateX(-50%);
    background: ${({ theme }) => theme.colors.activeColor};
    color: ${({ theme }) => theme.colors.bg};
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 4px 14px;
    border-radius: 20px;
    white-space: nowrap;
`;

export const PlanNameStyled = styled.h3`
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 4px 0;
    color: ${({ theme }) => theme.colors.cardText};
`;

export const PriceStyled = styled.div`
    margin: 8px 0 16px 0;
`;

export const PriceAmountStyled = styled.span`
    font-size: 32px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.cardText};
`;

export const PricePeriodStyled = styled.span`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.subTextColor};
    margin-left: 2px;
`;

export const CardCTAStyled = styled.button`
    width: 100%;
    padding: 10px 16px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    font-family: ${({ theme }) => theme.colors.ff};
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease;
    border: 1.5px solid ${({ theme }) => theme.colors.activeColor};
    background-color: ${({ $primary, theme }) =>
        $primary ? theme.colors.activeColor : 'transparent'};
    color: ${({ $primary, theme }) =>
        $primary ? theme.colors.bg : theme.colors.activeColor};
    &:hover {
        background-color: ${({ $primary, theme }) =>
            $primary ? theme.colors.activeColorDarkened : theme.colors.lightActiveHover};
        border-color: ${({ theme }) => theme.colors.activeColorDarkened};
    }
`;

export const TaglineStyled = styled.p`
    font-size: 13px;
    color: ${({ theme }) => theme.colors.subTextColor};
    margin: 12px 0 16px 0;
    line-height: 1.4;
`;

export const DividerStyled = styled.hr`
    width: 100%;
    border: none;
    border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
    margin: 0 0 16px 0;
`;

export const FeatureListStyled = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const CardFooterStyled = styled.div`
    margin-top: auto;
`;

export const FeatureItemStyled = styled.li`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.cardText};
    margin-bottom: 10px;
`;

export const CheckIconStyled = styled.span`
    color: ${({ theme }) => theme.colors.successColor};
    font-size: 14px;
    flex-shrink: 0;
`;

export const UseCaseStyled = styled.p`
    font-size: 12px;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.subTextColor};
    margin: 0;
    padding-top: 12px;
    font-style: italic;
    min-height: 90px;
`;

export const ButtonContainerStyled = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
`;
